<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 960 960">
    <title>Vai</title>
    <path
      d="M455.202 248.083c6.563-6.563 15.3-10.231 24.602-10.325 9.377-.079 18.238 3.515 24.97 10.121 6.717 6.622 10.457 15.418 10.55 24.787l3.139 326.489 98.568-98.568c13.812-13.812 36.289-13.807 50.107.011s13.822 36.295.011 50.107l-162.18 162.18c-13.818 13.818-36.3 13.818-50.117 0L292.616 550.649c-13.817-13.817-13.817-36.3 0-50.117s36.321-13.839 50.138-.022l105.352 105.352-3.207-332.499c-.095-9.549 3.565-18.541 10.304-25.28z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
